import { Draft, createSlice } from '@reduxjs/toolkit';
import { fetchProjectResponseRate } from 'reduxStore/responseRate/asyncActions';
import { Resource } from 'model/Resource';
import { ResponseRate } from 'model/ResponseRate';

import { ResponseRateState, STORE_NAME } from './initialState';

export const responseRateSlice = createSlice({
  name: STORE_NAME,
  initialState: ResponseRateState.INITIAL_DOMAIN,
  reducers: {
    clearResponseRate: (state) => {
      state.data = ResponseRateState.INITIAL_DOMAIN.data;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectResponseRate.pending, (state, action) => {
        state.data[action.meta.arg.projectId] = Resource.createPendingResource() as any;
      })
      .addCase(fetchProjectResponseRate.fulfilled, (state, action) => {
        state.data[action.meta.arg.projectId] = Resource.createResolvedResource({
          data: action.payload,
        }) as Draft<Resource<ResponseRate>>;
      })
      .addCase(fetchProjectResponseRate.rejected, (state, action) => {
        state.data[action.meta.arg.projectId] = Resource.createRejectedResource({
          error: action.payload ?? action.error,
        }) as Draft<Resource<ResponseRate>>;
      });
  },
});

export const { clearResponseRate } = responseRateSlice.actions;
